import { ACCESS_DOMAINS } from "@client";

export function checkSetUpQuery(
  projectId,
  pathName,
  companyId
) {
  return window.location.replace(
    ACCESS_DOMAINS.btApi +
    "check-set-up?project_id=" +
    projectId +
    "&pathName=" +
    pathName +
    "&company_id=" +
    companyId
  );
}